import { createContext } from 'react';

export const context = createContext<{
  contentTop: number;
}>(undefined as any);
